// ─── ACTION TYPES ─────────────────────────────────────────────────────────────

export const AVAILABILITY_MANAGEMENT_ACTIONS = {

	// ── Get Availability Management Tables ────────────────────────────────────
	AM_GET_TABLES_REQUEST: 'AM_GET_TABLES_REQUEST',
	AM_GET_TABLES_SUCCESS: 'AM_GET_TABLES_SUCCESS',
	AM_GET_TABLES_FAILURE: 'AM_GET_TABLES_FAILURE',

	// ── Update Availability Revised ───────────────────────────────────────────
	AM_UPDATE_REVISED_REQUEST: 'AM_UPDATE_REVISED_REQUEST',
	AM_UPDATE_REVISED_SUCCESS: 'AM_UPDATE_REVISED_SUCCESS',
	AM_UPDATE_REVISED_FAILURE: 'AM_UPDATE_REVISED_FAILURE',

};

// ─── ACTION CREATORS ──────────────────────────────────────────────────────────

// Get Availability Management Tables
export const amGetTablesRequest = ()        => ({ type: AVAILABILITY_MANAGEMENT_ACTIONS.AM_GET_TABLES_REQUEST });
export const amGetTablesSuccess = (payload) => ({ type: AVAILABILITY_MANAGEMENT_ACTIONS.AM_GET_TABLES_SUCCESS, payload });
export const amGetTablesFailure = (error)   => ({ type: AVAILABILITY_MANAGEMENT_ACTIONS.AM_GET_TABLES_FAILURE, error });

// Update Availability Revised
export const amUpdateRevisedRequest = ()      => ({ type: AVAILABILITY_MANAGEMENT_ACTIONS.AM_UPDATE_REVISED_REQUEST });
export const amUpdateRevisedSuccess = ()      => ({ type: AVAILABILITY_MANAGEMENT_ACTIONS.AM_UPDATE_REVISED_SUCCESS });
export const amUpdateRevisedFailure = (error) => ({ type: AVAILABILITY_MANAGEMENT_ACTIONS.AM_UPDATE_REVISED_FAILURE, error });
